import { LitElement, html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';

import { emit } from '@amityeko/pbc-core/dist/utilities/event';

import '@amityeko/design-system/dist/elements/typography/tg-body-two';
import '@amityeko/design-system/dist/elements/typography/tg-label-one';

import '../card-list';

import styles from './styles';

@customElement('rnr-top-achievement-list')
export default class RnRTopAchievementList extends LitElement {
  static styles = styles;

  @property({ type: Boolean })
  shouldShowHeader: boolean = true;

  @property({ type: Number })
  limit: number = 3;

  @property()
  receiverId?: string;

  @state()
  totalCount: number = 0;

  private _onClickViewAll() {
    emit(this, 'rnr-select-view-all');
  }

  private _getTotalCount(e: CustomEvent) {
    this.totalCount = e.detail?.totalCount;
  }

  private _onSelectCard(e: CustomEvent) {
    emit(this, 'rnr-top-achievement-select-card', {
      detail: { data: e?.detail, from: 'top-achievement' },
    });
  }

  protected render() {
    return html`
      <div class="achievement-container">
        ${this.shouldShowHeader
          ? html`
              <div class="achievement-header-container">
                <amityeko-tg-label-one>Achievements (${this.totalCount})</amityeko-tg-label-one>
                <amityeko-tg-body-two @click=${this._onClickViewAll}>View all</amityeko-tg-body-two>
              </div>
            `
          : null}
        <rnr-client-badge-card-list
          .limit=${this.limit}
          .receiverId=${this.receiverId}
          @rnr-change-total-count=${this._getTotalCount}
          @rnr-select-card=${this._onSelectCard}
        ></rnr-client-badge-card-list>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'rnr-top-achievement-list': RnRTopAchievementList;
  }
}
